import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserInterface } from '../../app/shared/interfaces/global';

@Injectable({
  providedIn: 'root',
})
export class UserHttpService {
  constructor(private $http: HttpClient) {}

  getProfile() {
    return this.$http.get<UserInterface>('profile');
  }

  updateProfile(body: any) {
    return this.$http.put<UserInterface>('profile', body);
  }

  loadAvatarToTemp(file: FormData) {
    return this.$http
      .post<{
        objectKey: string;
      }>('https://dev-upload.qform.io/global-upload-avatar/', file)
      .pipe(map((res) => res.objectKey));
  }

  uploadProfileAvatar(path: string) {
    return this.$http
      .post<{ Url: string }>('profile/store-avatar', { objectKey: path })
      .pipe(map((res) => res.Url));
  }
}
